import { render, staticRenderFns } from "./DiscountLandingPage.vue?vue&type=template&id=3446bb83&scoped=true&"
import script from "./DiscountLandingPage.vue?vue&type=script&lang=js&"
export * from "./DiscountLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLandingPage.vue?vue&type=style&index=0&id=3446bb83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446bb83",
  null
  
)

export default component.exports